import { IntermediaryViewContext } from '../TxocInterview/Intermediary';
import { QuestionContext } from '../Question';

export enum ContextType {
  Intermediary = 'intermediary',
  Question = 'question',
}
export function getContext(contextType: ContextType) {
  switch (contextType) {
    case ContextType.Intermediary:
      return IntermediaryViewContext;
    case ContextType.Question:
    default:
      return QuestionContext;
  }
}

export function getSubmitButtonVariant(text: string) {
  switch (text) {
    case 'Skip':
    case 'Next':
      return 'next';
    case 'Back':
      return 'back';
    case 'Restart':
      return 'restart';
    default:
      return 'default';
  }
}
